

class CartQuantityBlock extends HTMLElement {
 constructor() {
   super();
   this.inputField = this.querySelector(".cart_qty_field");
   this.increaseButton = this.querySelector(".increase_item_qty");
   this.decreaseButton = this.querySelector(".decrease_item_qty");
   this.itemId = this.inputField.dataset.id;


   this.attachEventListeners();
 }


 attachEventListeners() {
   if (this.increaseButton) {
     this.increaseButton.addEventListener("click", () => this.updateQuantity(1));
   }
   if (this.decreaseButton) {
     this.decreaseButton.addEventListener("click", () => this.updateQuantity(-1));
   }
   if (this.inputField) {
     this.inputField.addEventListener("change", () => this.handleInputChange());
   }
 }


 updateQuantity(changeBy) {
   const currentQuantity = parseInt(this.inputField.value, 10) || 0;
   const newQuantity = Math.max(0, currentQuantity + changeBy);
   this.inputField.value = newQuantity;
   // document.querySelector('[cart-drawer-wraper]')?.classList.add('is-loading-drawer')
   this.updateCart(newQuantity);
 }


 handleInputChange() {
   const newQuantity = Math.max(0, parseInt(this.inputField.value, 10) || 0);
   this.updateCart(newQuantity);
 }


async updateCart(quantity) {
 try {
   const response = await fetch("/cart/change.js", {
     method: "POST",
     headers: { "Content-Type": "application/json" },
     body: JSON.stringify({ id: this.itemId, quantity }),
   });


   if (response.ok) {
     const cartData = await response.json();
      refreshCart();
   } else {
     const errorData = await response.json();
     console.error("Failed to update cart:", errorData);
   }
 } catch (error) {
   console.error("Error updating cart:", error);
 }
}


}


customElements.define("quantity-block", CartQuantityBlock);
let itemfreechecked = false
var itemCountLoaded =  parseInt(document.querySelector('[cart-drawer-wraper]').getAttribute('data-count'))
 if(itemCountLoaded > 0){
       itemfreechecked = true
 }
class CartUpdater {
 constructor(cartContainerSelector) {
   this.cartContainerSelector = cartContainerSelector;
 }


 async fetchCartData() {
   try {
     const response = await fetch(window.location.pathname, {
       headers: { "Content-Type": "text/html" },
     });


     if (!response.ok) {
       throw new Error("Failed to fetch cart data");
     }


     return await response.text();
   } catch (error) {
     console.error("Error fetching cart data:", error);
     return null;
   }
 }


 async updateCartHTML() {
   const cartContainer = document.querySelector(this.cartContainerSelector);
   if (!cartContainer) {
     console.error(`Cart container not found for selector: ${this.cartContainerSelector}`);
     return;
   }


   const cartHTML = await this.fetchCartData();
   if (cartHTML) {
     const parser = new DOMParser();
     const doc = parser.parseFromString(cartHTML, "text/html");
     const cartCount = doc.querySelector('.header__cart__status');
     const newCartContent = doc.querySelector(this.cartContainerSelector);
     const itemCount =  parseInt(doc.querySelector(this.cartContainerSelector).getAttribute('data-count'))
      document.querySelectorAll('.header__cart__status')?.forEach(count => {
        count.innerHTML = cartCount.innerHTML
      })
     if (newCartContent) {
       cartContainer.innerHTML = newCartContent.innerHTML;
       cartContainer.setAttribute('data-count' , itemCount)
          if(itemfreechecked === false){
         localStorage.setItem("freeitemchecked", itemCount > 0);
       itemfreechecked = true
     }
     } else {
       console.error("Failed to find the new cart content in the fetched HTML.");
     }
   }
 }
}


window.CartUpdater = CartUpdater;


let _cartHtmlRefreshPromise = null;
let _cartHtmlRefreshOpenAfter = false;
let _themeCartChangeTimer;


function stripCartDrawerOpenState() {
 const timerDrawer = document.querySelector("[cart-drawer-wraper]");
 if (!timerDrawer) return;
 timerDrawer.classList.remove("is-open", "open", "drawer--is-open");
 if (window.cart) window.cart.cartDrawerIsOpen = false;
}


function openTimerCartDrawer() {
 const cartDrawerWrapperSelector = "[cart-drawer-wraper]";
 const timerDrawer = document.querySelector(cartDrawerWrapperSelector);
 if (!timerDrawer) return;


 document.querySelectorAll("[data-cart-drawer]").forEach((drawer) => {
   if (drawer !== timerDrawer) drawer.removeAttribute("data-cart-drawer");
 });


 if (!timerDrawer.hasAttribute("data-cart-drawer")) {
   timerDrawer.setAttribute("data-cart-drawer", "");
 }


 if (window.cart) {
   window.cart.cartDrawer = timerDrawer;
   window.cart.cart = timerDrawer;
 }


 document.querySelectorAll(".drawer--cart[data-cart-drawer]").forEach((drawer) => {
   if (drawer !== timerDrawer) {
     drawer.classList.remove("is-open", "open", "drawer--is-open");
   }
 });


 timerDrawer.classList.add("is-open", "open", "drawer--is-open");


 if (window.cart && window.cart.cartDrawer && window.cart.cartDrawer !== timerDrawer) {
   window.cart.cartDrawer = timerDrawer;
   window.cart.cart = timerDrawer;
   window.cart.cartDrawerIsOpen = true;
 }
}


function refreshCart(openDrawer = false) {
 clearTimeout(_themeCartChangeTimer);


 const cartWrapper = document.querySelector("[cart-drawer-wraper]");
 if (!cartWrapper) return Promise.resolve();


 _cartHtmlRefreshOpenAfter = _cartHtmlRefreshOpenAfter || openDrawer;


 if (_cartHtmlRefreshPromise) {
   if (_cartHtmlRefreshOpenAfter) stripCartDrawerOpenState();
   return _cartHtmlRefreshPromise;
 }


 if (_cartHtmlRefreshOpenAfter) stripCartDrawerOpenState();


 cartWrapper.classList.add("is-loading-drawer");
 const cartUpdater = new CartUpdater("[cart-drawer-wraper]");
 _cartHtmlRefreshPromise = cartUpdater
   .updateCartHTML()
   .then(() => {
     const shouldOpen = _cartHtmlRefreshOpenAfter;
     _cartHtmlRefreshOpenAfter = false;
     if (shouldOpen) openTimerCartDrawer();
     cartWrapper.classList.remove("is-loading-drawer");
   })
   .catch((error) => {
     cartWrapper.classList.remove("is-loading-drawer");
     _cartHtmlRefreshOpenAfter = false;
     console.error("Cart refresh failed:", error);
   })
   .finally(() => {
     _cartHtmlRefreshPromise = null;
   });


 return _cartHtmlRefreshPromise;
}


window.refreshTimerCart = refreshCart;
function startTimer() {
 if (window.__cartDrawerCountdownInterval) {
   clearInterval(window.__cartDrawerCountdownInterval);
 }
 window.__cartDrawerCountdownInterval = setInterval(() => {
 let time = parseInt(localStorage.getItem('timerTime'), 10);
 if (Number.isNaN(time)) time = 600;
 let reverse = false;
 try {
   reverse = JSON.parse(localStorage.getItem('timerReverse')) || false;
 } catch (e) {
   reverse = false;
 }
 const cartWrapper = document.querySelector('[cart-drawer-wraper]');
 if (!cartWrapper) return;
 let itemCount =  parseInt(cartWrapper.getAttribute('data-count'), 10) || 0;
 let hasFreeItem = localStorage.getItem("freeitemadded");
 let checkedFreeItem = localStorage.getItem("freeitemchecked");
 const freeItemCheckbox = cartWrapper.querySelector('#shppping_cart_checkbox');
 let freeitemId = freeItemCheckbox ? freeItemCheckbox.getAttribute('value') : cartWrapper.getAttribute('data-free-item-id');
 let freeitemLineId = freeItemCheckbox ? freeItemCheckbox.getAttribute('line-id') : cartWrapper.getAttribute('data-free-item-line-id');
 const countdownElement = cartWrapper.querySelector('.new_timer_cart_drawer .countdown');


 if (itemCount === 0) {
   localStorage.removeItem('timerTime');
   localStorage.removeItem('timerReverse');
 } else {
   if (countdownElement) {
     const minutes = Math.floor(time / 60);
     const seconds = time % 60;
     countdownElement.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
   }


   if (!reverse) {
     time--;
     if (time < 0) {
       reverse = true;
       time = 0;
     }
   } else {
     time++;
     if (time > 600) {
       reverse = false;
       time = 600;
     }
   }


   localStorage.setItem('timerTime', time);
   localStorage.setItem('timerReverse', JSON.stringify(reverse));
 }


   if(itemCount === 0  && hasFreeItem == "true" && freeitemId && freeitemLineId && checkedFreeItem == "true"){
     if (window.__cartDrawerFreeItemSyncPending) return;
     window.__cartDrawerFreeItemSyncPending = true;
     const checkbox = cartWrapper.querySelector('#shppping_cart_checkbox');
     if (checkbox) checkbox.checked = false;
     localStorage.setItem("freeitemadded", false);
    fetch(`/cart/change.js`, {
       method: "POST",
       headers: {
         "Content-Type": "application/json",
         "X-Requested-With": "XMLHttpRequest",
       },
       body: JSON.stringify({ id:freeitemLineId , quantity: 0 }),
     })
       .then((response) => response.json())
       .then(() =>  refreshCart())
       .catch((error) =>
         console.error("Error removing item from cart:", error)
       )
       .finally(() => {
         window.__cartDrawerFreeItemSyncPending = false;
       });
   }
    console.log('hasFreeItem' , itemCount > 0 , hasFreeItem , freeitemId ,  freeitemLineId)
   if(itemCount > 0  && hasFreeItem == "false" && freeitemId && checkedFreeItem == "true"){
     if (window.__cartDrawerFreeItemSyncPending) return;
     window.__cartDrawerFreeItemSyncPending = true;
     const checkbox = cartWrapper.querySelector('#shppping_cart_checkbox');
     if (checkbox) checkbox.checked = true;
     localStorage.setItem("freeitemadded", true);
    
     const data = {
       id: parseInt(freeitemId),
       quantity: 1
 };


 fetch('/cart/add.js', {
   method: 'POST',
   headers: {
     'Content-Type': 'application/json', // Equivalent to contentType
   },
   body: JSON.stringify(data) // Equivalent to data: JSON.stringify(data)
 })
   .then(response => {
     if (!response.ok) {
       throw new Error(`HTTP error! Status: ${response.status}`);
     }
     return response.json();
   })
   .then(() => {
     refreshCart();
   })
   .catch(error => console.error('Error adding item to cart:', error))
   .finally(() => {
     window.__cartDrawerFreeItemSyncPending = false;
   });
   }
 }, 1000);
}


  let itemCount =  parseInt(document.querySelector('[cart-drawer-wraper]').getAttribute('data-count'));
   localStorage.setItem("freeitemadded", false);
  let hasFreeItem = localStorage.getItem("freeitemadded");
 if(itemCount > 0 && hasFreeItem == "false"){
 localStorage.setItem("freeitemadded", true);
 } else{
 localStorage.setItem("freeitemadded", false);
 }
document.addEventListener('DOMContentLoaded', () => {
 startTimer();
      localStorage.setItem("freeitemchecked", itemCount > 0);


});


document.addEventListener('theme:cart:change', () => {
 clearTimeout(_themeCartChangeTimer);
 _themeCartChangeTimer = setTimeout(() => refreshCart(), 100);
});


document.addEventListener('theme:cart:open', () => {
 refreshCart(true);
});


if (!window.__globalCartDrawerActionsBound) {
 window.__globalCartDrawerActionsBound = true;
 document.addEventListener('click', (event) => {
   const cartWrapper = document.querySelector('[cart-drawer-wraper]');
   if (!cartWrapper) return;


   const closeButton = event.target.closest('[data-cart-drawer-close], [cart-drawer-close-btn], [data-drawer-underlay]');
   if (closeButton && cartWrapper.contains(closeButton)) {
     event.preventDefault();
     if (window.cart && typeof window.cart.closeCartDrawer === 'function') {
       window.cart.closeCartDrawer();
     } else {
       cartWrapper.classList.remove('is-open');
     }
     return;
   }


   const removeButton = event.target.closest('.remove_cart_item_btn');
   if (removeButton && cartWrapper.contains(removeButton)) {
     event.preventDefault();
     const removeId = removeButton.dataset.id;
     if (!removeId) return;


     cartWrapper.classList.add('is-loading-drawer');
     fetch('/cart/change.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json',
         'X-Requested-With': 'XMLHttpRequest',
       },
       body: JSON.stringify({ id: removeId, quantity: 0 }),
     })
       .then((response) => response.json())
       .then(() => refreshCart())
       .catch((error) => {
         cartWrapper.classList.remove('is-loading-drawer');
         console.error('Error removing item from cart:', error);
       });
   }
 });
}
//document.addEventListener('click', function(event){
 //  if(event.target.matches('[data-cart-drawer-close]') || event.target.closest('[data-cart-drawer-close]')){
 //      event.preventDefault();
 //    document.querySelector('[cart-drawer-wraper]')?.classList.remove('is-open')
 //  }
  //else  if(event.target.matches('[cart-toggle-btn]') || event.target.closest('[cart-toggle-btn]')){
 //   event.preventDefault();
 //   document.querySelector('[cart-drawer-wraper]')?.classList.toggle('is-open')
 // }else
  
 //   if(event.target.matches('.remove_cart_item_btn') || event.target.closest('.remove_cart_item_btn')){
 //   event.preventDefault();
 //   document.querySelector('[cart-drawer-wraper]')?.classList.add('is-loading-drawer')
 //   const targetRemove = event.target.matches('.remove_cart_item_btn') ? event.target : event.target.closest('.remove_cart_item_btn');
 //   const removeId = targetRemove.dataset.id;
 //   fetch("/cart/change.js", {
 //     method: "POST",
 //     headers: { "Content-Type": "application/json" },
 //     body: JSON.stringify({ id: removeId, quantity: 0 }),
 //   })
 //     .then(function (response) {
 //       if (response.ok) {
 //         return response.json();
 //       }
 //       return response.json().then(function (errorData) {
 //         throw new Error("Failed to remove item: " + JSON.stringify(errorData));
 //       });
 //     })
 //     .then(function (cartData) {
 //       console.log("Item removed successfully:", cartData);
 //        refreshCart();
 //     })
 //     .catch(function (error) {
 //       console.error("Error removing item from cart:", error);
 //     });
 // }
//})



















